import { useTranslation } from "react-i18next";
import getStyled from "../../../../hooks/getStyled";
import SFGenericSearch from "../../../typeahead/genericSearch";

const { styled } = getStyled();

const SFGenericSearchStyled = styled(SFGenericSearch)(
  ({ theme, hierarchyStyle }) => ({
    ...(hierarchyStyle && {
      "&:after": {
        content: "''",
        position: "absolute",
        left: "-12px",
        top: "-48px",
        width: "12px",
        height: "72px",
        borderWidth: 0,
        borderLeftWidth: "1px",
        borderBottomWidth: "1px",
        borderStyle: "dashed",
        borderColor: `${theme.palette.grey350.main} !important`,
      },
    }),
  }),
);

const SelectRenderer = ({
  config,
  generatedFilter,
  onChange,
  loading,
  hierarchyIndex,
  colDef,
}) => {
  const { t } = useTranslation();
  const nullValuesLabel =
    colDef?.nullValueFilterLabel ??
    colDef?.context?.nullValueFilterLabel ??
    t("components.datagrid.filters.blankValue");

  const handleChange = (values) => {
    if (config.loading) return;
    onChange(values.map((x) => (x === nullValuesLabel ? null : x)));
  };

  const optionRenderer = (option) => {
    if (option.value == null) {
      return nullValuesLabel;
    }
    return colDef.valueFormatter
      ? colDef.valueFormatter({ value: option.value })
      : option.value;
  };

  const selectedValues = generatedFilter?.values ?? [];
  return (
    <SFGenericSearchStyled
      loading={config.loading}
      hierarchyStyle={hierarchyIndex && hierarchyIndex > 0}
      source={config.values.map((value) => ({ value }))}
      selectedValues={selectedValues}
      hasSearchIcon
      disablePortal
      placeholder={t("components.datagrid.filters.searchLabel")}
      onClose={handleChange}
      multiple
      disabled={
        colDef.showBasicFilterDisabled ??
        colDef.context?.showBasicFilterDisabled
      }
      optionRenderer={optionRenderer}
    />
  );
};

export default SelectRenderer;
